import InvoiceInterface from "../interface/invoiceInterface";
import React from "react";
import { ProductState } from "../../Main/interface/MarketCartLocalstorage";
import { filter, find, get, map, pick } from "lodash";
import InvoiceRepository from "../repository/invoiceRepository";
import Toast from "../../../utility/toast";
import i18n from "../../../i18n";

export default class CheckAvailableProductController {
    protected state: InvoiceInterface;
    // protected repository: InvoiceInterface;
    protected setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>;


    constructor(state: InvoiceInterface, setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>) {
        this.state = state;
        this.setState = setState;
    }

    async checkOrders(items: ProductState[], shopId: string) {
        if (!items.length) return null;
        const result = items.map(item => pick({
            id: item._id,
            name: item.title,
            count: item.quantity,
            price: item.price
        }, ['id', 'name', 'count', 'price']));

        const isAvailable = await InvoiceRepository.checkOrder(result as any, shopId);

        if (!get(isAvailable, "status", false)) {
            Toast.error(i18n.t("toast.checkOrdersFailed"));
            return null;
        }

        const verifiedItems = map(items, item => {
            const matchedItem = find(get(isAvailable, "data", []), dataItem => dataItem.id === item._id);
            return {
                ...item,
                can: matchedItem ? matchedItem.can : false
            };
        });

        const invalidItems = filter(verifiedItems, item => !item.can);
        const paymentStatus = invalidItems.length === 0;

        return {
            payment: paymentStatus,
            invalidItems: paymentStatus ? [] : invalidItems
        };
    }

    clear() {
        this.updateState({
            notAvailableProduct: []
        })
    }

    private updateState(state: Partial<InvoiceInterface>) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}